import React from 'react';
import { compose } from 'redux';
import PageTitle from 'hoc/PageTitle';
import PageView from 'hoc/PageView';
import AuthTemplateContainer from 'containers/AuthTemplateContainer';
import LoginFormContainer from 'containers/LoginFormContainer';

const LoginPage = () => (
    <AuthTemplateContainer>
        <LoginFormContainer />
    </AuthTemplateContainer>
);

export default compose(
    // TODO: For now, we will hide the GWG from PageTitle to be safe. Futute enhancement
    // will be to pass a function in to PageTitle that looks at the whitelabel settings
    // based on subdomain.
    PageTitle({ pageTitle: 'Login', showGGBranding: false }),
    PageView({ page: 'Viewed Login Screen' })
)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/Login.js